import React from "react";
import { FormFields } from "../../../contexts/RegistrationContext";
import RegistrationBox from "../RegistrationBox";
import { OrangeRegistrationInput } from "../Inputs";
import { Col, Form, Row } from "antd";

const BusinessDetails = ({ missingFields }) => {
  const inputs = [
    FormFields.COMPANY_INFO.COMPANY_COUNTRY,
    FormFields.COMPANY_INFO.COMPANY_NUMBER,
    FormFields.COMPANY_INFO.COMPANY_TYPE,
    FormFields.COMPANY_INFO.COMPANY_NAME,
    FormFields.COMPANY_INFO.IN_BUSINESS,
    FormFields.COMPANY_INFO.SALES_REVENUE,
  ];

  return (
    <RegistrationBox
      title="קצת על העסק"
      className="agent-reg-stage-card"
      lead="נתאים את המערכת לאופן שבו אתם עובדים ומוכרים."
    >
      <Form layout="vertical" className="agent-reg-fields-form">
        <Row gutter={[14, 2]} className="agent-reg-fields-grid">
          {inputs.map((key) => (
            <Col xs={24} sm={12} key={key}>
              <OrangeRegistrationInput registrationKey={key} missingFields={missingFields} />
            </Col>
          ))}
        </Row>
      </Form>
    </RegistrationBox>
  );
};

export default BusinessDetails;
